// ── Shared collection helpers ────────────────────────────────────────────
// Ported from collection-frame.jsx `collectionHelpers`.

// Stable multi-key sort driven by the Options/column config. `__primary`
// resolves through config.primary; numeric fields compare numerically.
export function sortByConfig(results, colConfig, config, fieldDefinitions) {
  const fields = (fieldDefinitions && fieldDefinitions.fields) || {}
  const sortKeys = (colConfig || []).filter((c) => c.sort)
  if (!sortKeys.length) return results
  const isNum = (k) => k !== '__primary' && fields[k] && fields[k].type === 'number'
  const valueOf = (r, k) => (k === '__primary' ? (config.primary ? config.primary(r) : r[config.idKey || 'id']) : r[k])
  return [...results].sort((a, b) => {
    for (const { key, sort } of sortKeys) {
      let x = valueOf(a, key)
      let y = valueOf(b, key)
      let d
      if (isNum(key)) d = (Number(x) || 0) - (Number(y) || 0)
      else {
        x = String(x == null ? '' : x)
        y = String(y == null ? '' : y)
        d = x < y ? -1 : x > y ? 1 : 0
      }
      if (d !== 0) return sort === 'desc' ? -d : d
    }
    return 0
  })
}

// One column sorts at a time: `key` steps asc → desc → none and every other
// column drops its sort. Shared by the table's headers and the Options menu so
// the two cannot cycle differently.
export function withSort(colConfig, key) {
  const next = { asc: 'desc', desc: null }
  return colConfig.map((c) => ({ ...c, sort: c.key === key ? (c.sort ? next[c.sort] : 'asc') : null }))
}

// monogram + deterministic accent for media placeholders.
//
// The one palette here that is deliberately NOT read from the theme. These are
// identicon hues: their whole job is that two records hash to two colors a
// person can tell apart at a glance, and the preset names one accent. Mapping
// them onto brand tokens would either collapse the seven into one or invent six
// brand colors nobody chose. So they stay literal, and the ink drawn over them
// in RecordMonogram.vue is computed against the generated hue rather than
// against any surface the theme knows about.
const ACCENTS = ['#2A6FDB', '#1F8A5B', '#D97757', '#8b5cf6', '#0ea5e9', '#e0a82e', '#db2777']

export function accentFor(s) {
  let h = 0
  for (const c of String(s)) h = (h * 31 + c.charCodeAt(0)) % 2147483647
  return ACCENTS[h % ACCENTS.length]
}

export function monogram(s) {
  return String(s || '?')
    .replace(/[^A-Za-z0-9 ]/g, '')
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0].toUpperCase())
    .join('')
}

export const collectionHelpers = { sortByConfig, accentFor, monogram }
